/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { useContext } from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { GlobalContext } from "../../Context/GlobalContext";

const Index = () => {
  const { state, handleFunction } = useContext(GlobalContext);
  let { data, display, fetchStatus, setFetchStatus, truncateString } = state;

  let { fetchData } = handleFunction;

  useEffect(() => {
    if (fetchStatus === true) {
      fetchData();
      setFetchStatus(false);
    }
  }, [fetchData, fetchStatus, setFetchStatus]);

  return (
    <>
      <div className="container mx-auto px-4 sm:px-8">
        {display && (
          <div role="status">
            <svg
              aria-hidden="true"
              class="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
            <span class="sr-only">Loading...</span>
          </div>
        )}
      </div>
      <div>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <section className="bg-gray-200 p-5">
          <div className="container mx-auto flex-wrap flex gap-3 items-center justify-center">
            {/* Batas awal Card section */}
            {data !== null &&
              data.length !== 0 &&
              data.map((item, index) => {
                return (
                  <>
                  <Link to={`/dashboard/list-job-vacancy/detail/${item.id}`} value={item.id} key={item.id}>
                  <div className="w-full max-w-xs p-6 overflow-hidden bg-white shadow-lg rounded-xl dark:bg-gray-800">
                      <div className="flex flex-col items-center justify-between md:flex-row">
                        <div className="flex items-center justify-start flex-grow w-full">
                          <a href="#" className="relative block">
                            <img
                              alt="profil"
                              src={item.company_image_url}
                              className="mx-auto object-cover rounded-full h-10 w-10 "
                            />
                          </a>
                          <div className="flex flex-col items-start ml-4">
                            <span className="text-gray-700 dark:text-white">
                              {item.company_name}
                            </span>
                            <span className="text-sm font-light text-gray-400 dark:text-gray-300">
                              {item.job_tenure}
                            </span>
                          </div>
                        </div>
                        <div className="flex-none hidden md:block ">
                          <span className="w-full px-3 py-1 text-sm text-white bg-blue-500 rounded-full">
                            {item.title}
                          </span>
                        </div>
                      </div>
                      <p className="mt-4 mb-2 text-lg text-gray-800 dark:text-white">
                        {truncateString(item.job_qualification)}
                      </p>
                      <p className="text-sm font-normal text-gray-400">
                        {truncateString(item.job_description)}
                      </p>
                      <div className="flex items-center justify-between p-2 my-6 bg-blue-100 rounded">
                        <div className="flex items-start justify-between w-full">
                          <p className="flex-grow w-full text-2xl text-gray-700">
                            <span className="font-light text-gray-400 text-md">
                              Rp.
                            </span>
                            <h6>{item.salary_min} - {item.salary_max}</h6>
                            <span className="text-sm font-light text-gray-400">
                              /Month
                            </span>
                          </p>
                          <span className="flex-none px-3 py-1 text-sm text-indigo-500 border border-indigo-500 rounded-full">
                            {item.job_type}
                          </span>
                        </div>
                      </div>
                      <button
                        type="button"
                        className="py-2 px-4  bg-blue-600 hover:bg-blue-700 focus:ring-blue-500 focus:ring-offset-blue-200 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg "
                      >
                        Apply for this Job
                      </button>
                    </div>
                  </Link>
                  </>
                );
              })}
            {/* Batas akhir Card section */}
          </div>
        </section>
        {/* batas akhir Content Section */}
      </div>
    </>
  );
};

export default Index;
